import React from 'react'
import './style.scss'
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { updateConfigHeaderFooter } from '../../../actions';

import { Agenda } from '../../../pctComponents/organisms';

const Calendar = (props) => {
    
    const sMBClass = 'section_mb section_mb_m';
    const sMTClass = 'section_mt section_mt_m';

    const sectionMClass = sMBClass + ' ' + sMTClass;

    return (
        <div className="pctCalendarPage">
            <Agenda className={` ${sectionMClass}`} />
        </div>
    );
};

const mapDispatchToProps = (dispatch) => ({
    updateConfigHeaderFooter: (item) => dispatch(updateConfigHeaderFooter(item)),
});

export default compose(withRouter, connect(null, mapDispatchToProps))(Calendar);
